<!--
  @Author 22030124/xieyq
  @Date 2023-08-09 17:28:01
  @Description 人员选择弹层
-->
<template>
  <el-dialog
    v-if="isGenerate"
    ref="userSelectDialog"
    :class="scope.clsPrefix"
    :title="title"
    :close-on-click-modal="false"
    top="8vh"
    :visible.sync="isShow"
    width="900px"
    :append-to-body="true"
    :before-close="handleClose"
  >
    <!-- 搜索表单 -->
    <el-form
      @submit.native.prevent
      :class="`${scope.clsPrefix}_form`"
      ref="form"
      :inline="true"
      :model="queryParams"
      size="small"
    >
      <el-form-item>
        <el-input
          @keyup.enter.native="handkeyCode"
          v-model="queryParams.user"
          clearable
          maxlength="100"
          :placeholder="$t('common.selectUserPlaceholder')"
          @clear="search"
        >
          <el-button
            :class="`${scope.clsPrefix}_input-search`"
            slot="append"
            icon="el-icon-search"
            @click="search"
          ></el-button>
        </el-input>
      </el-form-item>
      <!-- <el-form-item :class="`${scope.clsPrefix}-switch`">
        <el-switch v-model="queryParams.isOnDuty" @change="search" />
        <span>在岗</span>
      </el-form-item> -->
    </el-form>
    <!-- <el-tabs :class="`${scope.clsPrefix}-tabs`" v-model="tabType" type="card" @tab-click="changeTab">
      <el-tab-pane
        v-for="item in tabs"
        :key="item.key"
        :name="item.key"
        :label="item.label"
        :lazy="true"> -->
    <!-- 表格 -->
    <cosmo-select-user-table
      v-if="isShow"
      :params="queryParams"
      key="all"
      ref="allEmpty"
      :item-data="tabs[3]"
      :operation="operationBtns"
      :selected-row="selectedRowData ? selectedRowData[valueKey] : ''"
      :selected-rows="selectedRowIds"
      :multiple="multiple"
      :tagLabel="tagLabel"
      :valueKey="valueKey"
      :disabled-keys="disabledKeys"
      @current-change="handleCurrentChange"
      @selection-change="handleSelectionChange"
      @unselection="handleUnsection"
      @operate="handleOperation"
    />
    <!-- </el-tab-pane>
    </el-tabs> -->
    <!-- 多选的时候需要显示对应的人员 -->
    <div
      :class="`${scope.clsPrefix}_selecteds`"
      v-if="selectedRows && selectedRows.length"
    >
      <el-tag
        type="success"
        v-for="item in selectedRows"
        :key="item[valueKey]"
        :closable="disabledKeys.indexOf(item[valueKey]) === -1 && multiple"
        @close="handleDel(item)"
        >{{ item[tagLabel] }}</el-tag
      >
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button size="small" @click="handleClose">{{ $t('common.cancel') }}</el-button>
      <el-button size="small" type="primary" @click="submit">{{ $t('common.confirm') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
// 人员表格
import CosmoSelectUserTable from './table.vue'
import {
  Dialog,
  Tag,
  Input,
  Form,
  FormItem,
  Button,
  Message
} from 'element-ui'
export default {
  // 组件名称
  name: 'CosmoSelectUserDialog',
  components: {
    CosmoSelectUserTable,
    // ElTabs: Tabs,
    // ElTabPane: TabPane,
    ElDialog: Dialog,
    ElTag: Tag,
    ElInput: Input,
    ElForm: Form,
    ElFormItem: FormItem,
    // ElSwitch: Switch,
    ElButton: Button
  },
  // 接收参数，currentUser当前用户
  inject: ['request', 'currentUser'],
  props: {
    // 弹窗标题
    title: {
      type: String,
      default: ''
    },
    // 是否多选
    multiple: {
      type: Boolean,
      default: false
    },
    // 置灰的数组
    disabledKeys: {
      type: [Array],
      default: () => []
    },
    // 格式化方法
    normalizer: {
      type: Function,
      default: (node) => {
        return node
      }
    },
    // 标签
    tagLabel: {
      type: String,
      default: 'name'
    },
    // 值的key
    valueKey: {
      type: String,
      default: 'userEmpsn'
    },
    // 是否是内部数据
    isInner: {
      type: Function,
      default: () => true
    }
  },
  // 数据
  data() {
    return {
      // 私有变量
      scope: {
        // class前缀
        clsPrefix: 'cosmo-select-user-dialog'
      },
      // 是否生成
      isGenerate: false,
      // 弹窗显示控制
      isShow: false,
      // 弹窗过滤参数
      queryParams: {
        // 姓名或工号
        user: '',
        // 是否在岗
        isOnDuty: true
      },
      // tab页签
      tabs: [
        {
          label: '常用联系人',
          key: 'frequent',
          // 请求api
          api: 'requestFrequentPerson'
        },
        {
          label: '部门联系人',
          key: 'depart',
          // 请求api
          api: 'requestDepartPerson'
        },
        {
          label: '收藏联系人',
          key: 'favorite',
          // 请求api
          api: 'requestFavoritePerson'
        },
        {
          label: '全部',
          key: 'all',
          // 请求api
          api: 'requestPerson'
        }
      ],
      // tab页签类型
      tabType: 'frequent',
      // 勾选的行数据
      selectedRowData: null,
      // 多选状态下的数据
      selectedRowDatas: []
    }
  },
  watch: {
    isShow(newVal, oldVal) {
      if (newVal === true) {
        this.search()
      }
    }
  },
  // 计算属性
  computed: {
    // 操作按钮
    operationBtns() {
      // 如果是收藏联系人，则显示取消收藏
      if (this.tabType === 'favorite') {
        return [
          {
            label: '取消收藏',
            key: 'cancelFavorite'
          }
        ]
      }
      return [
        {
          label: '收藏',
          key: 'favorite'
        }
      ]
    },
    // 选择行的id
    selectedRowIds() {
      return this.selectedRows.map((item) => item[this.valueKey])
    },
    // 勾选的行数据
    selectedRows() {
      return this.multiple
        ? this.selectedRowDatas
        : this.selectedRowData
          ? [this.selectedRowData]
          : []
    }
  },
  // 创建完成
  created() {
    // 初始化方法
    this.init()
  },
  mounted() {
    // this.$nextTick(() => {
    //   this.search()
    // })
  },
  methods: {
    /**
     * 初始化方法
     * @returns {void}
     */
    init() {
      // 此处是为了添加常用联系人的时候用
      // 当前选中
      this.selected = null
      this.multipleSelected = []
    },

    /**
     * 初始化弹窗
     * @param {Array} value 多选默认选中的值
     * @returns {void}
     */
    initDialog(value) {
      if (this.multiple) {
        // 多选勾选的行
        this.selectedRowDatas = value || []
        this.multipleSelected = value || []
      } else {
        // 单选
        this.selectedRowData = value
        this.selected = value
      }
      // 生成弹窗
      this.isGenerate = true
      // 显示弹窗
      this.isShow = true
      // 刷新对应的tab页签
      this.changeTab()
    },

    /**
     * 处理删除信息项
     * @param {Object} item 信息项数据
     * @returns {void}
     */
    handleDel(item) {
      // 多选
      if (this.multiple) {
        this.handleUnsection([item[this.valueKey]])
      } else {
        // 单选
        this.handleCurrentChange()
      }
      // nextTick保证参数传过去了~
      this.$nextTick(() => {
        // 每个标签页进行删除操作
        const tableRef = this.$refs.allEmpty
        // 如果table组件存在，则调用对应的更新选中方法
        if (tableRef) {
          tableRef.handleDel(item)
        }
      })
    },

    /**
     * 处理取消选中
     * @param {Aarry} ids 勾选的行数据id
     * @returns {void}
     */
    handleUnsection(ids) {
      // 过滤掉取消勾选的数据
      this.selectedRowDatas = this.selectedRowDatas.filter(
        (item) => ids.indexOf(item[this.valueKey]) === -1
      )
      this.multipleSelected = this.multipleSelected.filter(
        (item) => ids.indexOf(item.userEmpsn) === -1
      )
    },

    /**
     * 处理多选
     * @param {Aarry} val 勾选的行数据
     * @returns {void}
     */
    handleSelectionChange(val) {
      if (!val || !val.length) {
        return
      }
      // 新增的数据
      const newSelecteds = val.filter(
        (rowItem) => this.selectedRowIds.indexOf(rowItem.userEmpsn) === -1
      )
      // 如果新数据不存在，则进行直接退出
      if (!newSelecteds || !newSelecteds.length) {
        return
      }
      // 追加行数据
      this.selectedRowDatas = this.selectedRowDatas.concat(
        newSelecteds.map((item) => {
          return this.normalizer(item)
        })
      )
      // 多选新增
      this.multipleSelected = this.multipleSelected.concat(newSelecteds)
    },

    /**
     * 处理行选中
     * @param {Aarry} val 勾选的行数据
     * @returns {void}
     */
    handleCurrentChange(val) {
      // 单选赋值
      this.selected = val
      if (!val) {
        this.selectedRowData = val
        return
      }
      // 赋值勾选的行数据
      this.selectedRowData = this.normalizer ? this.normalizer(val) : val
    },

    /**
     * 修改tab页签
     * @returns {void}
     */
    changeTab() {
      // nextTick保证参数传过去了~
      this.$nextTick(() => {
        const tableRef = this.$refs[this.tabType]
        // 如果table组件存在，则调用对应的激活方法
        if (tableRef) {
          tableRef[0]?.activated()
        }
      })
    },

    /**
     * 处理操作按钮事件
     * @param {String} command 指令
     * @param {Object} rowItemData 行信息项数据
     * @returns {void}
     */
    handleOperation(command, rowItemData) {
      // 处理对应的指令事件处理方法
      this[`${command}Handle`] && this[`${command}Handle`](rowItemData)
    },

    /**
     * 收藏联系人
     * @param {Object} rowItem 行信息项数据
     * @returns {void}
     */
    favoriteHandle(rowItem) {
      // 调用收藏联系人接口
      this.request
        .requestFavoritePersonAdd(rowItem.id, {
          // 当前用户编码
          userEmpsn: this.currentUser
        })
        .then(() => {
          Message({
            message: '收藏成功',
            type: 'success'
          })
        })
        .catch(() => {
          console.log('收藏失败')
        })
    },

    /**
     * 收藏联系人
     * @param {Object} rowItem 行信息项数据
     * @returns {void}
     */
    cancelFavoriteHandle(rowItem) {
      // 调用取消收藏联系人接口
      this.request
        .requestFavoritePersonCancel(rowItem.id, {
          // 当前用户编码
          userEmpsn: this.currentUser
        })
        .then(() => {
          Message({
            message: '取消收藏成功',
            type: 'success'
          })
          // 触发当前tab页签刷新
          this.changeTab()
        })
        .catch(() => {
          console.log('收藏失败')
        })
    },

    /**
     * 新增常用联系人
     * @returns {void}
     */
    addFrequentPerson() {
      // 如果是多选
      if (this.multiple) {
        // 批量新增常用联系人
        if (!this.multipleSelected || !this.multipleSelected.length) {
          return
        }
        // 结果
        const result = this.multipleSelected.filter((item) =>
          this.isInner(item)
        )
        // 如果有新增，则调用接口
        if (result && result.length) {
          this.request
            .requestFrequentPersonAddBatch({
              // 用户ID列表，数组
              frequentUserIdList: result.map((item) => item.id),
              // 当前用户编码
              userEmpsn: this.currentUser
            })
            .then(() => {
              console.log('新增常用联系人成功！')
            })
        }
        return
      }
      // 单选
      // 如果没有勾选人，则直接退出
      if (!this.selected || !this.selected.id) {
        return
      }
      // 调用新增常用联系人接口
      this.request
        .requestFrequentPersonAdd(this.selected.id, {
          // 当前用户编码
          userEmpsn: this.currentUser
        })
        .then(() => {
          console.log('新增常用联系人成功！')
        })
      return
    },

    // 确认选择
    submit() {
      this.isShow = false
      // 新增常用联系人接口
      // this.addFrequentPerson()
      this.$emit(
        'submit',
        this.multiple ? this.selectedRowDatas : this.selectedRowData
      )
    },

    /**
     * 处理关闭
     * @returns {void}
     */
    handleClose() {
      this.isShow = false
      this.queryParams = {
        // 姓名或工号
        user: '',
        // 是否在岗
        isOnDuty: true
      }
      this.selectedRowIds = []
      this.selectedRowDatas = []
      this.selectedRowData = null
      this.$emit('onClose')
    },

    /**
     * 搜索方法
     * @returns {void}
     */
    search() {
      // 点击搜索切换到全部页签
      this.tabType = 'all'
      // 生效之后再进行触发搜索
      this.$nextTick(() => {
        // 如果生成对应的表格，则触发搜索方法，没有生成会自动进行查询
        this.$refs.allEmpty.search()
      })
    },
    // 回车查询
    handkeyCode(e) {
      if (e.keyCode === 13) {
        this.search()
      }
    }
  }
}
</script>

<style lang="scss">
// 组件样式
$class-prefix: "cosmo-select-user-dialog";
.#{$class-prefix} {
  .el-dialog {
    display: flex;
    flex-direction: column;
    max-height: 92vh !important;
    overflow: auto;
  }
  // 对话框头部
  .el-dialog__header {
    padding: 15px 24px;
    line-height: normal;
    border-bottom: 1px solid #f0f0f0;
  }
  // 对话框标题
  .el-dialog__title {
    font-size: 16px;
    font-weight: 600;
    color: #262626;
  }
  // 主体样式
  .el-dialog__body {
    flex: 1;
    display: flex;
    flex-direction: column;
    padding: 23px;
    border-bottom: 1px solid #f0f0f0;
    padding-bottom: 16px;
  }
  // 表单
  &_form {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 0;
    .el-form-item--small.el-form-item {
      margin-bottom: 16px;
    }
  }
  // tab页签
  &-tabs.el-tabs--card {
    flex: 1;
    // 不允许缩小
    flex-shrink: 0;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    .el-tabs__content {
      flex: 1;
      overflow: auto;
    }
    > .el-tabs__header {
      border-bottom: none;
      .el-tabs__nav {
        border: none;
      }
      .el-tabs__item {
        border: 1px solid #e4e7ed;
        padding: 0 20px;
        height: 32px;
        line-height: 32px;
        font-size: 14px;
        font-weight: 400;
        background-color: #fff;
        // 鼠标滑过样式
        &:hover {
          color: #0055ff;
          background-color: #fff;
        }
        // 选中样式
        &.is-active {
          color: #0055ff;
          border: 1px solid #0055ff;
          background-color: #fff;
        }
      }
    }
  }
  // 开关信息项
  &-switch {
    .el-form-item__content {
      display: flex;
      gap: 10px;
      align-items: center;
    }
  }
  // 选中的信息项容器
  &_selecteds {
    position: relative;
    display: flex;
    flex-wrap: wrap;
    gap: 16px;
    padding-top: 16px;

    &:before {
      content: "";
      position: absolute;
      top: 0;
      left: -23px;
      right: -23px;
      height: 1px;
      background-color: #f0f0f0;
    }
  }

  .el-switch.is-checked .el-switch__core {
    border-color: #0055ff;
    background-color: #0055ff;
  }
  // 弹层底部
  .el-dialog__footer {
    .el-button--default {
      color: #262626;
      border-color: #d9d9d9;
      &:hover,
      &:active,
      &:focus {
        border-color: #0055ff;
        color: #0055ff;
        background-color: #fff;
      }
    }

    // 按钮
    .el-button--primary {
      color: #fff;
      border: none;
      background-color: #4a5ff3 !important;
      &:hover,
      &:active,
      &.is-active,
      &:focus {
        color: #fff;
        background-color: #476dff !important;
      }
      // 置灰
      &.is-disable {
        &,
        &:hover {
          color: #81abff;
          background-color: #81abff;
        }
      }
    }
  }
}
</style>
